import { PropTypes } from 'prop-types'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import {currencyTypes, slaTypes} from 'utils/Constants'
import {useParams} from 'react-router-dom'
import {useState} from 'react'
import {useRequest} from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import moment from 'moment'
import {Calendar} from 'primereact/calendar'
import {InputNumber} from 'primereact/inputnumber'
import { Checkbox } from "primereact/checkbox";

const SlaModalContent = ({handleClose,handleAdd}) => {
    const {projectId} = useParams()
    const [saveSla] = useRequest()
    const {showToast} = useToast()
    const [addForm, setAddForm] = useState({
        projectId: projectId,
        signatureDate: null,
        startDate: null,
        endDate: null,
        type: null,
        monthlyManDay: null,
        budget: null,
        currency: null,
        invoiceStatusId: null,
        isAutoInvoice:false,
        invoicePiece:null,
        periodInvoice:null,
        periodStartDate:null,
      })
      useState(() => {
        if (addForm.isAutoInvoice == false) {
            setAddForm({...addForm,invoicePiece:null,
                periodInvoice:null,
                periodStartDate:null,})
        }
      },[addForm.isAutoInvoice])
      const handleChange =(e) => {
        setAddForm(prev => ({...prev,[e.name]:e.value ? e.value : null}))
      }
      const handleSubmit = () => {
        if (addForm.type.length < 1) {
            showToast('Lütfen Tipini Seçin','error')
        }
        else if(addForm.isAutoInvoice && !addForm.budget) {
            showToast('Fatura Kaydı Oluşturabilmek İçin Lütfen Bütçe Giriniz', 'error')
       }
       else if(addForm.isAutoInvoice && (!addForm.invoicePiece || !addForm.periodInvoice || !addForm.periodStartDate)) {
            showToast('Lütfen Oluşturulacak Faturaların Bilgilerini Doldurunuz','error')
       }
       else {
        saveSla('/SLAs/AddSLAs',{
            method:'POST',
            data:{...addForm,type:addForm.type && addForm?.type?.map(t => t.value)?.join('+')}
        }).then(res => {
            if (res.data.ok) {
                showToast('Sla Oluşturuldu','success')
                handleClose()
                handleAdd()
            }else {
                showToast('Bir Hata Oluştu','error')
            }
        })
       }
      }
  return (
    <div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
        <div className="row">
        <div className='col-md-6'>
            <div className='form-control'>
                <Calendar
                    dateFormat='dd/mm/yy'
                    placeholder='Dönem Başlangıç Tarihi'
                    name='startDate'
                    onChange={(e) => {
                        handleChange({ name:e.target.name, value:moment(e.target.value).add(3,'hours').toISOString() })
                    }}
                />
            </div>
        </div>
        <div className='col-md-6'>
            <div className='form-control'>
                <Calendar
                    dateFormat='dd/mm/yy'
                    placeholder='Dönem Bitiş Tarihi'
                    name='endDate'
                    onChange={(e) => {
                        handleChange({ name:e.target.name, value:moment(e.target.value).add(3,'hours').toISOString() })
                    }}
                />
            </div>
        </div>
       
    </div>
    <div className="row">
        <div className='col-md-6'>
            <div className='form-control'>
                <InputNumber mode="decimal" minFractionDigits={2} maxFractionDigits={2} placeholder='Bütçe' name='budget' onChange={(e) => handleChange({name:'budget',value:e.value})}  />
            </div>
        </div>
        <div className='col-md-6'>
            <div className='form-control'>
                <DefaultSelect
                placeholder='Para Birimi'
                 selectOptions={currencyTypes}
                 handleChange={(e) => handleChange(e)}
                />
            </div>
        </div>
       
    </div>
    <div className="row">
    <div className='col-md-12'>
            <div className='form-control'>
                <DefaultSelect
                 placeholder='Tipi'
                 isMulti
                 selectOptions={slaTypes}
                 handleChange={(e) => handleChange({name:'type',value:e})}
                />
            </div>
        </div>
    </div>
    {
        addForm?.type?.find(t => t.value == 'M/D') && <div className="row">
        <div className='col-md-12'>
            <div className='form-control'>
                <input
                    placeholder='Adam/Gün'
                    className='default-input'
                    type='text'
                    disabled={!addForm?.type?.find(t => t.value == 'M/D')}
                    name='monthlyManDay'
                    onChange={(e) =>{
                        // eslint-disable-next-line no-useless-escape
                        e.target.value = e.target.value.replace(/[^0-9.-]/g, '').replace(/(\..*)\./g, '$1')
                        // eslint-disable-next-line no-useless-escape
                        handleChange({value:e.target.value.replace(/[^0-9.-]/g, '').replace(/(\..*)\./g, '$1'),name:e.target.name})
                    }}
                />
            </div>
        </div>
    </div>
    }
     <div className="row">
        <div className="col-md-12">
            <div className="form-control flex-row gap-2">
                <Checkbox id='isSingleInvoice' checked={addForm.isAutoInvoice} onChange={() => setAddForm(prev => ({...prev,isAutoInvoice:!prev.isAutoInvoice}))}/>
                <label htmlFor="isSingleInvoice" className="form-control-label">Faturalar otomatik oluşturulsun mu?</label>
            </div>
        </div>
    </div>
    {
        addForm.isAutoInvoice &&  <div className="row">
        <div className='col-md-4'>
            <div className='form-control'>
                <InputNumber mode="decimal" placeholder='Fatura Adedi' name='invoicePiece' onChange={(e) => handleChange({name:'invoicePiece',value:e.value})}  />
            </div>
        </div>
        <div className='col-md-4'>
            <div className='form-control'>
            <InputNumber mode="decimal" placeholder='Fatura Aralığı(Ay)' name='periodInvoice' onChange={(e) => handleChange({name:'periodInvoice',value:e.value})}  />
            </div>
        </div>
        <div className='col-md-4'>
            <div className='form-control'>
                <Calendar
                    dateFormat='dd/mm/yy'
                    placeholder='Faturaların Başlangıç Tarihi'
                    name='periodStartDate'
                    onChange={(e) => {
                        handleChange({ name:e.target.name, value:moment(e.target.value).add(3,'hours').toISOString() })
                    }}
                />
            </div>
        </div>
    </div>
    }
    <div className="row justify-content-center">
        <div className="col-md-4">
            <Button handleClick={handleSubmit} className='btn-success w-100 justify-content-center' title={'Ekle'} />
        </div>
        <div className="col-md-4">
            <Button handleClick={handleClose} className='btn-danger-outline w-100 justify-content-center' title={'Vazgeç'} />
        </div>
    </div>
</div>
  )
}
SlaModalContent.propTypes = {
    handleClose: PropTypes.func,
    handleAdd: PropTypes.func,
  }
export default SlaModalContent